import BaseStore from '@src/utils/store/base-store';
// import useMount from '@src/utils/hooks/use-mount';

import useModal from '@src/utils/hooks/use-modal';
import PreviewQrcodeModalStore from '@src/business-components/modal/preview-qrcode/store';
import PreviewQrcodeModal from '@src/business-components/modal/preview-qrcode';
import { observable } from 'mobx';
import createHtmlLink from '@src/utils/create-html-link';
import $$tracker from '@src/tracker';

class Part4Store extends BaseStore {
  @observable
  channelList = [
    {
      icon: require('./images/icon-gzh.png'),
      name: '微信公众号',
      url: '',
      type: 'weixin',
      qrcodeImg: require('./images/gongzhonghao.png')
    },
    {
      icon: require('./images/icon-dy.png'),
      name: '官方抖音',
      url: 'https://v.douyin.com/xr8y3iqGI_M/'
      // ,qrcodeImg: require('./images/douyin.png')
    },
    {
      icon: require('./images/icon-kf.png'),
      name: '客服管家',
      type: 'custom_service',
      url: '',
      qrcodeImg: require('./images/kefu.png')
    },
    {
      icon: require('./images/icon-wb.png'),
      name: '游戏微博',
      url: 'https://weibo.com/u/7478851023'
      // ,qrcodeImg: require('./images/weibo.png')
    }
  ];
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }
  previewQrcodeModalStore = new PreviewQrcodeModalStore({ parentStore: this });

  /** 打开预约弹窗 */
  onReservation = () => {
    if (this.mainStore?.projectConfig?.phone) return;
    $$tracker.clickReservation('底部');
    this.mainStore?.openOrderTipsModal();
  };
  onItemClick = item => {
    if (item?.url) {
      createHtmlLink(item.url).click();
      return;
    }
    if (item?.qrcodeImg) {
      this.qrcodeModal.open();
      this.previewQrcodeModalStore.qrcodeImg = item.qrcodeImg;
      this.previewQrcodeModalStore.type = item.type;
    }
  };
  use() {
    this.qrcodeModal = useModal(PreviewQrcodeModal, { store: this.previewQrcodeModalStore });
  }
}

export default Part4Store;
